import { render, staticRenderFns } from "./App.vue?vue&type=template&id=047c1845&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=047c1845&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047c1845",
  null
  
)

export default component.exports